'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.unslugify = unslugify;
exports.rando = rando;
exports.slugify = slugify;
exports.translations = translations;
exports.referrize = referrize;
exports.capitalize = capitalize;
function unslugify(slugs) {

  slugs = slugs.replace(/_/g, '-');
  slugs = slugs.replace(/--/g, '-');

  var list = [];
  slugs.split('-').forEach(function (slug) {
    list.push(slug.substr(0, 1).toUpperCase() + slug.substr(1));
  });
  return list.join(' ');
}

function rando(arr) {
  return arr[Math.floor(Math.random() * arr.length)];
}

function slugify(text) {
  return text.toString().toLowerCase().replace(/\s+/g, "-").replace(/[^\w-]+/g, "").replace(/--+/g, "-").replace(/^-+/, "").replace(/-+$/, "");
}

function translations(s) {
  if (typeof iconPressConfig.translations == 'undefined') {
    return;
  }
  return iconPressConfig.translations[s];
}

function referrize(url) {
  var r = 'iconpress';
  var rf = 'ref';

  if (url.indexOf('iconfinder.com') !== -1) {
    return url + '?' + rf + '=' + r;
  }

  return url;
}

function capitalize(str) {
  return str.charAt(0).toUpperCase() + str.substr(1);
}


//////////////////
// WEBPACK FOOTER
// ./src/helpers.js
// module id = 94
// module chunks = 0 1